import { render } from "./PhotoSuggestionsLayer.vue?vue&type=template&id=20960194"
import script from "./PhotoSuggestionsLayer.vue?vue&type=script&lang=js"
export * from "./PhotoSuggestionsLayer.vue?vue&type=script&lang=js"

import "./PhotoSuggestionsLayer.vue?vue&type=style&index=0&id=20960194&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__